module.exports = __webpack_public_path__ + "static/blog-15-25c5dffd2a872e19bf5460ad98e8b785.png";